import { OptionItem } from 'components/DataEntry/Button/types';

export const vulnerabilityButtonGroupOptions: OptionItem[] = [
  { label: 'Open', value: 'open', key: 'open' },
  { label: 'Resolved', value: 'resolved', key: 'resolved' },
];
